import { Grid } from "@mui/material";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { useEffect, useState } from "react";
import moment from "moment";
import { Convert, ConvertDateToUnixOrNull } from "utilities/utilities";

const DateRangeProject = (props) => {

    const {
        NameStart,
        NameEnd,
        LabelStart,
        LabelEnd,
        IsMonthYearPicker = false,
        IsYearPicker = false,
        IsMonthPicker = false,
        required = false,
        isDisableYear = false,
        nYearMapper = null,
        nTrigger,
        onChange,
        nID,
        minDate,
        maxDate,
        disabled = false,
        formatDefault, 
        form,
    } = props;

    const [sMin, setSMin] = useState(null);
    const [sMax, setSMax] = useState(null);

    const [_dStart, setdStart] = useState(null);
    const [_dEnd, setdEnd] = useState(null);

    const handleChangeStart = (event, nID, type) => {
        if (onChange) {
            onChange(event, nID, type);
        }
        setSMin(event);
    }

    const handleChangeEnd = (event, nID, type) => {
        if (onChange) {
            onChange(event, nID, type);
        }
        setSMax(event);
    }

    useEffect(() => {
        let nYearStart = Convert.StringToInt(moment(minDate).format("YYYY"));
        if(nYearStart < nYearMapper){
            setdStart(null);
        }else{
            setdStart(moment(minDate).year((isDisableYear === true ? new Date().getFullYear() : nYearMapper)));
        }

        let nYearEnd = Convert.StringToInt(moment(maxDate).format("YYYY"));
        if(nYearEnd > nYearMapper){
            setdEnd(null);
        }
        else{
            setdEnd(moment(maxDate).year((isDisableYear === true ? new Date().getFullYear() : nYearMapper)));
        }
        // let dDateStart = moment(minDate).year(nYearMapper);
        // let dDateEnd = moment(maxDate).year(nYearMapper);
        // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "dd MM YYYY");
        // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "dd sMM YYYY");

        setSMin(null);
        setSMax(null);

        if (form && NameStart && NameEnd) {
            setSMin(form.getValues(NameStart));
            setSMax(form.getValues(NameEnd));
        }
    }, [nTrigger])
    
    // useEffect(() => {
    //     let _nYearMapper = nYearMapper;
    //     let dDateStart = moment(_dStart);
    //     let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "DD MM YYYY");
    //     console.log("dDateStart", dDateStart);
    //     console.log("sDateStart", sDateStart);
    //     let dDateEnd = moment(_dEnd);
    //     let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "DD MM YYYY");
    //     console.log("dDateEnd", dDateEnd);
    //     console.log("sDateEnd", sDateEnd);
    // }, [_dStart, _dEnd, nYearMapper])

    //// console.log("nTrigger", nTrigger);
    //// console.log("dStart_", _dStart ? Convert.DateTimeToString(_dStart, "DD MM YYYY") : null);
    //// console.log("dEnd_", _dEnd ? Convert.DateTimeToString(_dEnd, "DD MM YYYY") : null);

    return (
        <Grid item xs={12} md={12} container spacing={1} direction="row" alignItems="start">
            <Grid item xs={5.8}>
                <DatePickerItem
                    id={NameStart}
                    name={NameStart}
                    label={LabelStart}
                    IsMonthYearPicker={IsMonthYearPicker}
                    IsYearPicker={IsYearPicker}
                    IsMonthPicker={IsMonthPicker}
                    required={required}
                    isDisableYear={isDisableYear}
                    // nYearMapper={nYearMapper}
                    minDate={_dStart}
                    maxDate={sMax || _dEnd}
                    // defaultValue={_dStart}
                    onChange={(e) => handleChangeStart(e, nID, "start")}
                    disabled={disabled}
                    // // defaultCalendarMonth={_dStart}
                    // // defaultCalendarMonth={moment(_dStart).startOf('year').year(new Date().getFullYear())}
                    // defaultCalendarMonth={_dStart !== null ? moment(_dStart).startOf('month').year(new Date().getFullYear()) : null}
                    // // defaultCalendarMonth={moment(_dStart)}
                    // // defaultCalendarMonth={moment().startOf('year').year(new Date().getFullYear())}
                    defaultCalendarMonth={_dStart !== null ? moment(_dStart).startOf('month') : null}
                    format={formatDefault}
                    IsDisablePortal={true}
                />
            </Grid>
            <Grid item style={{marginTop: '2%'}}> - </Grid>
            <Grid item xs={5.7}>
                <DatePickerItem
                    id={NameEnd}
                    name={NameEnd}
                    label={LabelEnd}
                    IsMonthYearPicker={IsMonthYearPicker}
                    IsYearPicker={IsYearPicker}
                    IsMonthPicker={IsMonthPicker}
                    required={required}
                    isDisableYear={isDisableYear}
                    // nYearMapper={nYearMapper}
                    minDate={sMin || _dStart}
                    maxDate={_dEnd}
                    onChange={(e) => handleChangeEnd(e, nID, "end")}
                    disabled={disabled}                    
                    // defaultCalendarMonth={_dStart !== null ? moment(_dStart).startOf('month').year(new Date().getFullYear()) : null}
                    defaultCalendarMonth={_dStart !== null ? moment(_dStart).startOf('month') : null}
                    format={formatDefault}
                    IsDisablePortal={true}
                />
            </Grid>
        </Grid>    
    )
}
export default DateRangeProject;